import { render, staticRenderFns } from "./correct-index.vue?vue&type=template&id=368fa1a1&scoped=true&"
import script from "./correct-index.vue?vue&type=script&lang=js&"
export * from "./correct-index.vue?vue&type=script&lang=js&"
import style0 from "./correct-index.vue?vue&type=style&index=0&id=368fa1a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368fa1a1",
  null
  
)

export default component.exports